import {style, keyframes} from 'typestyle'
import * as csstips from 'csstips'

export const topBanner = style({
    width: '100%',
    cursor: 'pointer'
})

export const bannerImg = style({
    position: 'relative',
    width: '100%'
})

export const NoSubscribeImg = style({
    height: 'auto'
})

const breathe = keyframes({
    from: {transform: 'scale(1.05)'},
    to: {transform: 'scale(1)'}
})

export const topBannerButton = style({
    position: 'absolute',
    bottom: 9,
    left: '50%',
    transform: 'translate(-50%, 0)'
})

export const btnImg = style({
    'position': 'absolute',
    'width': '53%',
    'height': '24.8%',
    'left': '23%',
    'bottom': '11.6%',
    '-webkit-animation-timing-function': 'cubic-bezier(0.25,0.1,0.25,1)',
    '-webkit-animation-name': breathe,
    '-webkit-animation-duration': '500ms',
    '-webkit-animation-iteration-count': 'infinite',
    '-webkit-animation-direction': 'alternate'
})

export const topBannerButtonText = style({
    'width': '53.33vw',
    'maxWidth': '256px',
    'height': 44,
    'borderRadius': 44,
    'background': 'linear-gradient(180deg, #FFF72D, #FFAE14)',
    '-webkit-animation-timing-function': 'cubic-bezier(0.25,0.1,0.25,1)',
    '-webkit-animation-name': breathe,
    '-webkit-animation-duration': '500ms',
    '-webkit-animation-iteration-count': 'infinite',
    '-webkit-animation-direction': 'alternate',
    ...csstips.flexRoot,
    ...csstips.centerJustified,
    ...csstips.center,
    'color': '#D31900',
    'fontSize': 20,
    'fontWeight': 600,
    'boxShadow': '0 3px 8px 0 rgba(255,156,0,0.50)'
})



// WEBPACK FOOTER //
// ./src/views/FreeLecture/components/TopBanner/TopBanner.style.ts